import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  width: 940px;
  background: #efefef;
  border-radius: 8px;
  display: inline-block;
  padding: 10px 20px;
  margin-bottom: -55px;
  height: 60px;
  box-shadow: 0 0 15px #dcdcdc;
  overflow: hidden;

  &.is-expanded {
    height: unset;
    margin-bottom: 20px;

    ${mediaMaxWidth.smallDesktop} {
      margin-bottom: 15px;
    }
  }

  ${mediaMaxWidth.smallDesktop} {
    width: calc(100vw - 80px);
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
  }
`;

export const Header = styled.div`
  border-bottom: 1px solid #efefef;
  color: #343333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 7px 0;
  display: flex;
  justify-content: space-between;
  transition: 0.2s ease-in-out;

  &.is-expanded {
    border-bottom: 1px solid #d8d8d8;
  }

  ${mediaMaxWidth.tablet} {
    font-size: 0.85em;
  }
`;

export const HeaderText = styled.div``;

export const ToggleView = styled.div`
  cursor: pointer;
  text-decoration: underline;
  font-weight: 300;
`;

export const AgentWrapper = styled.div`
  display: flex;
  border-bottom: 1px solid #d8d8d8;
  padding: 15px 10px;
  opacity: 0.6;
  position: relative;

  &:last-child {
    border-bottom: none;
  }
`;

export const AgentDetails = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

export const Avatar = styled.div`
  width: 100px;

  ${mediaMaxWidth.phone} {
    display: none;
  }
`;

export const AvatarImage = styled.img`
  width: 85px;
  height: 85px;
  border-radius: 4px;
  object-fit: cover;
`;

export const TextDetails = styled.div``;

interface INameProps {
  psl?: boolean;
}

export const Name = styled.div`
  font-weight: bold;
  font-family: Komet;
  color: #333;
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;

  &:after {
    content: "PSL";
    width: 20px;
    height: 20px;
    color: #666;
    padding: 1px 5px;
    margin-left: 5px;
    font-family: sans-serif;
    letter-spacing: 0.05em;
    font-weight: bold;
    font-size: 0.7em;
    border-radius: 8px;
    border: ${(props: INameProps) => props.psl && "1px solid #666"};
    background-color: ${(props: INameProps) => props.psl && "#fff"};
    display: ${(props: INameProps) => (props.psl ? "inline" : "none")};
    text-transform: uppercase;
    position: relative;
    top: -2px;
  }

  ${mediaMaxWidth.phone} {
    width: 220px;
  }
`;

export const NameLink = styled.a`
  text-decoration: underline !important;
  color: #333 !important;
  transition: 0.1s ease-in-out;

  &:hover {
    color: #402680 !important;
  }
`;

export const Company = styled.div`
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.85em;
`;

export const ActiveSince = styled.div`
  width: 195px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.85em;
`;

export const StarRating = styled.div`
  unicode-bidi: bidi-override;
  color: #ccc;
  font-size: 16px;
  position: relative;
  padding: 0;
  width: 80px;
`;

export const StarRatingLabel = styled.label`
  font-size: 0.85em;
  line-height: 1.42857;
  color: #565656;
  font-weight: 400;
`;

export const Stars = styled.span``;

export const FillRating = styled.div`
  color: #79D9D9;
  padding: 0;
  position: absolute;
  display: block;
  top: 0;
  left: 60px;
  z-index: 1;
  overflow: hidden;

  span {
    display: inline-block;
  }
`;

export const EmptyRating = styled.div`
  padding: 0;
  display: block;
  z-index: 0;
  position: absolute;
  left: 60px;
  top: 0px;
`;

export const NoRatings = styled.div`
  font-size: 0.85em;
  margin-top: 2px;
`;

export const Actions = styled.div`
  display: flex;
  width: 50px;
`;

export const HHScore = styled.div`
  font-size: 0.85em;
  line-height: 1.42857;
  color: #565656;
  font-weight: 400;
  margin-top: 2px;
`;

export const Score = styled.span`
  font-family: sans-serif;
  color: #79D9D9;
  font-weight: 700;
`;
